import request from '@/utils/util.request';
/**
 * @desc (home)加载数据
 */
export const home_load_data = (data = {}) => {
	return request({
		url: '/home/loaddata',
		data,
	});
};

/**
 * @desc (home)分页加载设备list
 * @param { int } offset 起始量
 * @param { int } limit 加载量
 */
export const load_device_list = (data) => {
	return request({
		url: '/home/loaddevicelist',
		data,
	});
};

/**
 * @description (home) 切换当前设备
 * @param { string | int } device_id 设备id
 */
export const select_device = (data) => {
	return request({
		url: '/home/selectdevice',
		data,
	});
};

/**
 * @desc (home) 设备当前任务状态
 */
export const home_device_tasks = (data) => {
	return request({
		url: '/home/devicetasks',
		data,
	});
};
